export default __webpack_public_path__ + "static/media/Union 7.da0447f2.svg";